module.exports = __webpack_public_path__ + "static/media/RaisingChildren_android_1_preview.fd155829.jpg";